import React from 'react';
import MetaData from '../layout/MetaData';

const PrivacyPolicy = () => (
  <>
    <MetaData title="Privacy Policy" />
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-8">
          <div className="card p-4">
            <div className="card-body">
              <h1 className="mb-2 fw-bold text-center">Privacy Policy</h1>
              <p className="text-muted text-center mb-4">Effective date: October 1, 2025</p>
              <hr />

              <h4 className="mt-4">1. Introduction</h4>
              <p>MBZ Transport ("we", "our", or "us") provides vehicle booking and logistics services through our mobile application and website (the "Service"). This Privacy Policy explains what personal and device data we collect, how we use and share it, your rights, and how to contact you.</p>

              <h4 className="mt-4">2. Data We Collect</h4>
              <p>We collect the following categories of information:</p>
              <ul>
                <li><strong>Account information:</strong> name, email address, phone number, profile photo, and password (hashed).</li>
                <li><strong>Location data:</strong> approximate and precise device location (GPS) when you request or use a ride.</li>
                <li><strong>Payment information:</strong> payment method token or details necessary to process payments.</li>
                <li><strong>Driver and trip information:</strong> driver name, vehicle details, trip origin and destination, trip time, ratings and reviews.</li>
                <li><strong>Device & usage data:</strong> device model, operating system version, app version, crash logs, IP address, and analytics data.</li>
              </ul>

              <h4 className="mt-4">3. How We Use Your Data</h4>
              <p>We use collected information to provide and operate the Service, process trip requests and payments, match riders with drivers, communicate updates, improve the Service, and comply with legal obligations.</p>

              <h4 className="mt-4">4. Security & Data Retention</h4>
              <p>We use reasonable safeguards to protect personal data. We retain personal data as long as necessary to provide the Service, comply with legal obligations, and resolve disputes.</p>

              <h4 className="mt-4">5. Your Rights</h4>
              <p>You may have rights including access, correction, deletion, restriction of processing, and data portability. To exercise your rights, contact us at <a href="mailto:support@mbztransport.com">support@mbztransport.com</a> or call <a href="tel:+923378233366">0337 8233366</a>.</p>

              <h4 className="mt-4">6. Changes to This Policy</h4>
              <p>We may update this Privacy Policy from time to time. When we do, we will revise the effective date and notify users. Continued use after changes constitutes acceptance of the updated policy.</p>

              <h4 className="mt-4">7. Contact Us</h4>
              <ul>
                <li>Email: <a href="mailto:support@mbztransport.com">support@mbztransport.com</a></li>
                <li>Phone: <a href="tel:+923378233366">+92 337 8233366</a></li>
                <li>Address: MBZ Transport, Karachi, Sindh, Pakistan</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default PrivacyPolicy;